import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type {
  ApiError,
  RabbitPublishRequest,
  RabbitPublishResponse,
  RabbitReceivedResponse,
  RabbitStatusResponse,
} from '../types/showcase';

/**
 * GET /api/eraf/showcase/demo/rabbitmq/status — C057 상태 조회
 * queryKey: ['common-showcase', 'rabbitmq', 'status']
 */
export function useRabbitStatus() {
  return useQuery<RabbitStatusResponse, ApiError>({
    queryKey: ['common-showcase', 'rabbitmq', 'status'],
    queryFn: () => showcaseApi.rabbitStatus(),
    staleTime: 15_000,
  });
}

/**
 * GET /api/eraf/showcase/demo/rabbitmq/received?limit=20 — 수신 목록 조회
 * queryKey: ['common-showcase', 'rabbitmq', 'received', limit]
 * enabled: false — publish 성공 후 자동 1회 폴링 + 수동 [재조회] 버튼으로 트리거
 */
export function useRabbitReceived(limit = 20) {
  return useQuery<RabbitReceivedResponse, ApiError>({
    queryKey: ['common-showcase', 'rabbitmq', 'received', limit],
    queryFn: () => showcaseApi.rabbitReceived(limit),
    enabled: false,
  });
}

/**
 * POST /api/eraf/showcase/demo/rabbitmq/publish — 메시지 발행
 * 성공 시 status 캐시 무효화 (receivedCount 등 갱신)
 */
export function useRabbitPublish() {
  const queryClient = useQueryClient();
  return useMutation<RabbitPublishResponse, ApiError, RabbitPublishRequest>({
    mutationFn: (req) => showcaseApi.rabbitPublish(req),
    mutationKey: ['common-showcase', 'rabbitmq', 'publish'],
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['common-showcase', 'rabbitmq', 'status'] });
    },
  });
}
